import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import storageSession from 'redux-persist/lib/storage/session'

import ReduxThunk from 'redux-thunk'

import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'

import zoneReducer from '../features/Zone/zoneSlice'
import zonesDetectorReducer from '../features/zonesDetector/zonesDetectorSlice'
import userReducer from '../features/user/userSlice'
import userLocationReducer from '../features/userLocation/userLocationSlice'
import poiReducer from '../features/poi/poiSlice'
import mapsReducer from '../features/maps/mapsSlice'
import dossierReducer from '../features/dossier/dossierSlice'
import sceneReducer from '../features/scene/sceneSlice'
import puzzleReducer from '../features/puzzle/puzzleSlice'
import scriptReducer from '../features/script/scriptSlice'
import phoneReducer from '../features/phone/phoneSlice'
import subwayReducer from '../features/subway/subwaySlice'

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

const reducers = combineReducers({
  detectedZones: zonesDetectorReducer,
  zone: zoneReducer,
  user: userReducer,
  userLocation: userLocationReducer,
  poi: poiReducer,
  maps: mapsReducer,
  dossier: dossierReducer,
  scene: sceneReducer,
  puzzle: puzzleReducer,
  script: scriptReducer,
  phone: phoneReducer,
  subway: subwayReducer,
  // ...(process.env.NODE_ENV === 'development' ? { debug: debugReducer } : {}),
})

const persistConfig = {
  key: 'root',
  storage: storageSession, //storage, // or storageSession
  // whitelist: ['activePOI', 'activeScene', 'myLocation', 'case'],
  whitelist: ['user', 'detectedZones', 'zone', 'maps'], // only persist this
  blacklist: ['userLocation', 'poi', 'dossier', 'scene', 'puzzle', 'phone'],
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production' && {
    name: 'Capitol Noir',
    trace: true, // Optional: action tracing support
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        // Ignore redux-persist action types
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(ReduxThunk),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store)
